<script>
    import { Link } from "svelte-navigator";
    export let title = "Airshow in Bern";
    export let mainImageSrc;
    export let teaser = "Teasertext der Airshow";
    export let slug;
</script>
<article class="airshow-card">
    <figure>
        <Link to="/airshows/{slug}">
            <img src="{mainImageSrc}" alt="Titelbild - {title}" loading="lazy">
        </Link>
        <figcaption>
            <Link to="/airshows/{slug}">
                <h2>{title}</h2>
            </Link>
            <div class="teaser">{@html teaser}</div>
            <!--<Link class="link-btn black" to="/airshows/{slug}">Bilder ansehen</Link>-->
        </figcaption>
    </figure>
</article>
<style lang="scss">
    article {
        background-color: var(--background);
        width: 100%;
        box-shadow: var(--box-shadow);
        img {
          width: 100%;
        }
      figcaption {
        padding: calc(var(--default-margin) / 2);
        :global(.link-btn) {
          margin-top: 20px;
        }
      }
    }
</style>